import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const RequestInfoStyles = styled.div`
  .modal-container {
    width: 95%;
  }
  .request-info-container {
    padding: 40px;
    p,
    h3 {
      text-align: center;
    }
    .error-message {
      text-align: left;
    }
    h3 {
      text-transform: capitalize;
    }
    form {
      margin-top: 30px;
      button {
        margin-top: 30px;
      }
    }
    .disclaimer {
      margin-top: 20px;
      text-align: left;
      padding: 0;
    }
    .illustration {
      text-align: center;
      margin-top: 50px;
      margin-bottom: 25px;
    }
    .thank-you-text {
      padding-bottom: 65px;
    }
    .written-text-check label {
      font-size: 16px;
    }
    .sms-disclaimer {
      text-align: left;
      margin-left: 32px;
      font-size: 12px;
      line-height: 17px;
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    padding-top: 0;

    .form-row-name {
      display: flex;
      justify-content: space-between;

      > div {
        width: 48%;
      }
    }
  }
`;
